import React from 'react'
import { Box, Typography, Container, Grid, Button } from "@mui/material"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, Rectangle } from 'recharts';
import { useState,useEffect } from 'react';

const Dashboard_Graphic = ({ tekrarlananAksyionTipleri, tekrarlananSorunTipleri }) => {

    const [tekrarlananSorunTipleri_sort, setTekrarlananSorunTipleri_sort] = useState()
    const [tekrarlananAksiyonTipleri_sort, setTekrarlananAksiyonTipleri_sort] = useState()

    useEffect(() => {

        const sortDataSorunTipleri = tekrarlananSorunTipleri.sort((a,b)=>{
            const aSort = a.tekrar
            const bSort = b.tekrar

            return bSort-aSort
        })
        setTekrarlananSorunTipleri_sort(sortDataSorunTipleri)


        const sortDataAksiyonTipleri = tekrarlananAksyionTipleri.sort((a,b)=>{
            const aSort = a.tekrar
            const bSort = b.tekrar

            return bSort-aSort
        })
        setTekrarlananAksiyonTipleri_sort(sortDataAksiyonTipleri)

    }, [tekrarlananSorunTipleri, tekrarlananAksyionTipleri])
    


    return (
        <Box height={600} display={'flex'} justifyContent={'center'} gap={8} flexWrap={'wrap'}>

            <ResponsiveContainer width="100%" height="100%">
                <Typography align='center' variant='subtitle1' sx={{height:'20px',fontWeight:700}}>Bölüm Uygunsuzluk</Typography>
                <BarChart
                    // width={600}
                    // height={400}
                    data={tekrarlananAksiyonTipleri_sort}
                >
                    <XAxis dataKey="tekrar" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="tekrar" fill="#F3B95F">
                        <LabelList dataKey="aksiyontipi" position="top" fill='#000000' fontSize={12} />

                    </Bar>

                </BarChart>
            </ResponsiveContainer>


            <ResponsiveContainer width="100%" height="100%">
            <Typography align='center' variant='subtitle1' sx={{height:'20px',fontWeight:700}}>Uygunsuzluk Çeşidi</Typography>
                <BarChart
                    // width={600}
                    // height={400}
                    data={tekrarlananSorunTipleri_sort}
                >
                    <XAxis dataKey="soruntipi" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="tekrar" fill="#FF6868">
                        <LabelList dataKey="tekrar" position="top" fill='#000000' fontSize={14} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>


        </Box>
    )
}

export default Dashboard_Graphic